import Vue from 'vue';

const stripe = window.Stripe(process.env.VUE_APP_STRIPE_PK);
const ls = window.localStorage;

Vue.prototype.$pay = function pay(plan) {
  const sku = plan === 'month' ? process.env.VUE_APP_STRIPE_SKU_MONTH : process.env.VUE_APP_STRIPE_SKU_LIFETIME;
  const verifyToken = Math.random().toString(32) + Math.random().toString(32);
  const success = this.$router.resolve({ name: 'Home', query: { s: verifyToken } }).href;
  const cancel = this.$router.resolve({ name: 'Home', query: { cancel: 1 } }).href;

  ls.setItem('__verifyToken', verifyToken);
  ls.setItem('__plan', plan);

  stripe.redirectToCheckout({
    items: [{ sku, quantity: 1 }],
    successUrl: `${window.location.protocol}//${window.location.host}${success}`,
    cancelUrl: `${window.location.protocol}//${window.location.host}${cancel}`,
  }).then((result) => {
    this.$trackError(result.error);
    this.$addMessage(result.error.message, 'danger');
  });

  this.$trackCategory('STRIPE', 'click on buy', `From ${window.document.title}`);
};

export const isValidToken = (token) => {
  const lsToken = ls.getItem('__verifyToken');

  if (token && lsToken && token === lsToken) {
    ls.removeItem('__verifyToken');
    return true;
  } else {
    return false;
  }
};

export const getPlan = () => {
  const plan = ls.getItem('__plan');
  ls.removeItem('__plan');
  return plan;
};

export default null;
